import {ObjUtil, Util} from 'yougile-util'
import {NotificationSettings, SandboxTree} from 'yougile-model'
import {apiChatList} from '@api/components/api-chat-list'
import {ChatFilterState} from '@extensions/app-persistence'
import {ChatUtils} from '@extensions/chat-utils'
import {ChatProxy} from '@extensions/proxies/chat-proxy'
import {chatsCache, ensureCacheInitialized} from './ensure-cache-initialized'

let oldFilter: ChatFilterState
let oldSettings: NotificationSettings

export const getChats = (
  box: SandboxTree,
  filter: ChatFilterState,
  useOldFilter = false,
  notificationSettings: NotificationSettings = {}
): ChatProxy[] => {
  ensureCacheInitialized()

  if (useOldFilter && !oldFilter) {
    return []
  }

  if (useOldFilter) {
    filter ??= oldFilter
  }

  if (apiChatList.areDefaultFiltersDisabled) {
    filter = {
      ...filter,
      myTasks: true,
      otherTasks: true,
      personal: true,
      groupChats: true,
      privateTasks: true
    }
  }

  if (
    !oldFilter ||
    !ObjUtil.deepEqual(oldFilter, filter, true) ||
    !oldSettings ||
    !ObjUtil.deepEqual(oldSettings, notificationSettings, true)
  ) {
    chatsCache.clear()
    oldFilter = Util.clone(filter)
    oldSettings = Util.clone(notificationSettings)
  }

  const {companyId} = box

  if (chatsCache.has(companyId)) {
    return chatsCache.get(companyId) ?? []
  }

  const chats = ChatUtils.getChats(box, filter)

  chatsCache.set(companyId, chats)

  return chats
}
